import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PaginatedResult } from '../../shared/models/paginated-result';
import { AUTH_SERVER_URL } from '../../config';
import { OrderBy } from '../../shared/utils/constant';
import { Users, FieldOfUsers, UsersDatacenter, FieldOfUsersDatacenter } from '../models/user';

const GET_USER_URL = `${ AUTH_SERVER_URL }/v2/users`;

const GET_USERS_DATACENTER = `${ AUTH_SERVER_URL }/v3/users-datacenter`;

@Injectable({ providedIn: 'root' })
export class UserService {
	constructor(
		private readonly http: HttpClient
	) {}

	getAllUsers(
		fields: readonly FieldOfUsers[] | string[],
		filter: string | undefined,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof Users>[] | OrderBy<keyof Users>,
		onlyDistinct: boolean
	) {
		const url = new URL(GET_USER_URL);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));

		params.append('distinct', String(onlyDistinct));

		return this.http.get<PaginatedResult<Users>>(url.toString());
	}

	getUsersDatacenter(
		fields: readonly FieldOfUsersDatacenter[] | string[],
		filter: string | undefined,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof UsersDatacenter>[] | OrderBy<keyof UsersDatacenter>,
		onlyDistinct: boolean
	) {
		const url = new URL(GET_USERS_DATACENTER);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			const modifiedFilter = filter.replace('role:"subscription"', 'userType:"subscription"');
			params.append('filter', modifiedFilter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));

		params.append('distinct', String(onlyDistinct));

		return this.http.get<PaginatedResult<UsersDatacenter>>(url.toString());
	}
}
